// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__Alr8a","col":"Table_col__1KTnY","fulfillmentStatus":"Table_fulfillmentStatus__e4K8-","emailCol":"Table_emailCol__154_1"};